import { render, staticRenderFns } from "./VoteArea.vue?vue&type=template&id=1b308d04&scoped=true&"
import script from "./VoteArea.vue?vue&type=script&lang=js&"
export * from "./VoteArea.vue?vue&type=script&lang=js&"
import style0 from "./VoteArea.vue?vue&type=style&index=0&id=1b308d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b308d04",
  null
  
)

export default component.exports